import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { UserService } from 'src/services/user.service';

@Component({
  selector: 'dialog-user-msg',
  templateUrl: './dialogUserMessage.component.html',
  styleUrls: ['dialogUserMessage.component.scss']
})
export class DialogUserMessageComponent implements OnInit {
  public message: string;
  public showMessageUntil: Date;

  constructor(
    private dialogRef: MatDialogRef<DialogUserMessageComponent>,
    private usrSvc: UserService,
    private http: HttpClient
  ) {
  }

  private tryParseDate(val: any): Date | null {
    if (!val) return null;
    const d = new Date(val);
    if (isNaN(d.getTime())) return null;
    return d;
  }

  ngOnInit(): void {
    const user$ = this.usrSvc.getUser().pipe(take(1), catchError(_ => of(null)));
    const ladderMeta$ = this.http.get<any>('/api/playerapi').pipe(take(1), catchError(_ => of(null)));

    forkJoin([user$, ladderMeta$]).subscribe(([player, meta]) => {
      this.message = (player as any)?.message || (player as any)?.Message || '';

      const savedUntil = (player as any)?.showMessageUntil ?? (player as any)?.ShowMessageUntil;
      this.showMessageUntil = this.tryParseDate(savedUntil) || null;

      if (!this.showMessageUntil) {
        const ladderEndDate = meta?.results?.[0]?.ladderEndDate ?? meta?.Results?.[0]?.ladderEndDate;
        this.showMessageUntil = this.tryParseDate(ladderEndDate) || null;
      }
    });
  }

  public cancel(evt?: any) {
    if (evt?.preventDefault) evt.preventDefault();
    this.dialogRef.close();
  }

  public clearReset(evt?: any) {
    if (evt?.preventDefault) evt.preventDefault();
    this.usrSvc.setUserMessage('', null).pipe(take(1)).subscribe(
      (_player) => this.dialogRef.close(),
      (err) => alert(err)
    );
  }

  public save() {
    this.usrSvc.setUserMessage(this.message, this.showMessageUntil).subscribe(
      (player) => this.dialogRef.close(player),
      (err) => alert(err)
    )
  }
}